import * as model from "@/model/master/Location";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}
 
export default newEntityStoreHelper(() => new model.Location(), newFilter)
    .withStates({
        idReport: 2,
    childs: [],
    locationList: [],
    crudState: 'list',
     enterpriseCBO: [],
     siteCBO: [],
     areaCBO: [],
     workCenterCBO: [],

     baseModuleUrl : process.env.VUE_APP_MASTER_API_URL + "master-service/master"
    }) //TODO load at the application start
    .withActions({
    loadChildOf(context){
        context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/location/findToFilterByWork"
        }, 
        {root: true})
        .then(function(data){
          context.commit("setChilds", data);
        })
    },
    loadLocationList(context){
        context.dispatch("api/get", {
            url: context.state.baseModuleUrl + "/location/findAll"
        },
        {root: true})
        .then(function(data){
            context.commit("setLocationList", data);
        })
    },
    loadLocationByType(context, {type, idLoc}){
        context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/location/findToFilterByType/"+type+"/"+idLoc
        }, 
        {root: true})
        .then(function(data){
            switch (type) {
                case 'E':
                    context.commit("setEnterpriseCBO", data);
                break;
                case 'A':
                    context.commit("setAreaCBO", data);
                break;
                case 'S':
                    context.commit("setSiteCBO", data);
                break;
                case 'W':
                    context.commit("setWorkCenterCBO", data);
                break;
            }
        })
    },
    selectParentLocal(context, type){
        var enty1 = JSON.parse(JSON.stringify(context.state.entity));
        
        switch (type) {            
            case 'E':
                context.dispatch("loadLocationByType", {type:'S', 
                idLoc: context.state.entity.enterprise});
                enty1.locationParent = context.state.entity.enterprise;
            break;
            case 'S':
                context.dispatch("loadLocationByType", {type:'A', 
                idLoc: context.state.entity.site});
                enty1.locationParent = context.state.entity.site;
            break;
            case 'A':
                context.dispatch("loadLocationByType", {type:'W', 
                idLoc: context.state.entity.area});
                enty1.locationParent = context.state.entity.area;
            break;
        }
        context.commit("setEntity", enty1);
    }
    })
    .withMutations({
    setChilds(state, childs) {
        state.childs = childs;
    },
    setLocationList(state, locationList) {
        state.locationList = locationList;
    },
    setEnterpriseCBO(state, enterpriseCBO) {
        state.enterpriseCBO  = enterpriseCBO;
    },
    setSiteCBO(state, siteCBO) {
        state.siteCBO  = siteCBO;

    },
    setAreaCBO(state, areaCBO) {
        state.areaCBO  = areaCBO;
    },
    setWorkCenterCBO(state, workCenterCBO) {
        state.workCenterCBO  = workCenterCBO;
    },
    })
    .buildStore()